(() => {
  const initialized = new WeakSet();

  function placeCreativeCards(root = document) {
    const grids = root.matches?.('#product-grid') ? [root] : root.querySelectorAll?.('#product-grid') || [];

    grids.forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll('[data-collection-creative]'));
      cards.forEach((card) => {
        if (initialized.has(card)) return;

        const products = Array.from(grid.children).filter(
          (item) => !item.matches('[data-collection-creative], .collection__card-text')
        );
        if (!products.length) return;

        const isRandom = card.dataset.randomize === 'true';
        const minimum = Math.max(1, Number(card.dataset.randomMin) || 1);
        const maximum = Math.min(products.length, Number(card.dataset.randomMax) || products.length);
        const lower = Math.min(minimum, maximum);
        const upper = Math.max(minimum, maximum);
        const position = isRandom
          ? Math.floor(Math.random() * (upper - lower + 1)) + lower
          : Math.min(products.length, Math.max(1, Number(card.dataset.position) || 1));
        const target = products[position - 1];

        if (target) grid.insertBefore(card, target);
        else grid.appendChild(card);
        initialized.add(card);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => placeCreativeCards());
  document.addEventListener('shopify:section:load', (event) => placeCreativeCards(event.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) placeCreativeCards(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
